import { DETAIL } from './common';

const PERSPECTIVES = 'perspectives';

export const perspectiveQueryKeys = {
    all: [PERSPECTIVES],
    detail: (nodeId?: string) => [PERSPECTIVES, DETAIL, String(nodeId)]
};
